// post API
export const postContacturl = `${process.env.REACT_APP_BACKENDURL}/contact`;
export const postFeedbackurl = `${process.env.REACT_APP_BACKENDURL}/feedback`;
export const postSlotbookurl = `${process.env.REACT_APP_BACKENDURL}/book-slot`;
export const postRegisterurl = `${process.env.REACT_APP_BACKENDURL}/register`;
export const postAnnouncement = `${process.env.REACT_APP_BACKENDURL}/admin/announcement`;

// Get API
export const getFeedbackurl = `${process.env.REACT_APP_BACKENDURL}/feedback`;
export const getSpecificourt = `${process.env.REACT_APP_BACKENDURL}/courtslots`;
export const getAnnouncement = `${process.env.REACT_APP_BACKENDURL}/admin/announcement`;
export const getMembershipurl = `${process.env.REACT_APP_BACKENDURL}/admin/users`;
export const getContact = `${process.env.REACT_APP_BACKENDURL}/contact`;
export const getReservedslot = `${process.env.REACT_APP_BACKENDURL}/bookings`;
export const getProductsByShopName = (branchName) =>
  `${process.env.REACT_APP_BACKENDURL}/shops/${branchName}`;
// export const getProductsByShopName = `https://aegcdm8115.execute-api.ap-south-1.amazonaws.com/Prod/shops/KOSMOSRUWIBRANCH`;

// GetByTag announce API
export const getAnnouncebyTag = `${process.env.REACT_APP_BACKENDURL}/announcement/active`;

// announce patch api
export const patchAnnouncement = `${process.env.REACT_APP_BACKENDURL}/admin/announcement`;

// delete api
export const deleteAnnouncement = `${process.env.REACT_APP_BACKENDURL}/admin/announcement/delete-multiple`;
export const deleteContact = `${process.env.REACT_APP_BACKENDURL}/admin/contact/delete-multiple`;
export const deleteFeedbackurl = `${process.env.REACT_APP_BACKENDURL}/admin/feedback/delete-multiple`;
export const deleteSingleFeedback = `${process.env.REACT_APP_BACKENDURL}/admin/feedback`;
export const deleteRerveredslot = `${process.env.REACT_APP_BACKENDURL}/admin/delete-reservations`;
export const deleteRegistrationurl = `${getMembershipurl}/delete-multiple`;

// update API
export const putRegisterurl = `${process.env.REACT_APP_BACKENDURL}/user`;
export const updateReservation = `${process.env.REACT_APP_BACKENDURL}/admin/reservations`;

// dashboard API
export const dashboardapi = `${process.env.REACT_APP_BACKENDURL}/admin/count`;

// Price API
export const addPrice = `${process.env.REACT_APP_BACKENDURL}/add-price`;
export const getPrice = `${process.env.REACT_APP_BACKENDURL}/get-price`;

// kosmos-branches API
export const createProduct = `${process.env.REACT_APP_BACKENDURL}/admin/shop`;
export const fetchRuwibranch = `${process.env.REACT_APP_BACKENDURL}/shops/KOSMOSRUWIBRANCH`
export const fetchGhalabranch = `${process.env.REACT_APP_BACKENDURL}/shops/KOSMOSGHALABRANCH`;
export const fetchRiyazbranch = `${process.env.REACT_APP_BACKENDURL}/shops/KOSMOSRIYAZBRANCH`
export const deleteProductCategory = `${process.env.REACT_APP_BACKENDURL}/admin/category/delete`;
export const putProductCategory = `${process.env.REACT_APP_BACKENDURL}/admin/category`;
export const deletebrand = `${process.env.REACT_APP_BACKENDURL}/admin/brands`;
export const putProductbrand = `${process.env.REACT_APP_BACKENDURL}/admin/brand`;
export const updateProduct = `${process.env.REACT_APP_BACKENDURL}/admin/product/update`;
export const deleteProduct = `${process.env.REACT_APP_BACKENDURL}/admin/products/delete-multiple`;



export const showNotificationsURL = `${process.env.REACT_APP_BACKENDURL}/admin/notification`;
export const viewNotificationURL = `${process.env.REACT_APP_BACKENDURL}/admin/notifications/viewed`;

// login api
export const postlogin = `${process.env.REACT_APP_BACKENDURL}/admin/login`;

export const getDisablecourt = `${process.env.REACT_APP_BACKENDURL}/admin/disabled/courts`;
export const deleteUnblockedcourt = `${process.env.REACT_APP_BACKENDURL}/admin/unblock/courts`;
export const postBlockedcourt = `${process.env.REACT_APP_BACKENDURL}/admin/block/court`;

export const bookSlot = `${process.env.REACT_APP_BACKENDURL}/book-slot`;
export const courtAvailability = `${process.env.REACT_APP_BACKENDURL}/court-availability-range`;